import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  supplier: '',
  supplierID: '',
  supplierOfferID: '',
  submissionDate: '',
  releaseDate: '',
  pricingProfileID: '',
  pricingProfileName: '',
  pricingProfileDetail: null,
  costCurrency: '',
  costCurrencySymbol: '',
  purchaseOrderProducts: [],
  currAddProducts: [],
  baseCurrency: '',
  baseCurrencySymbol: '',
  shippingTerms: '',
  shippingTermsID: '',
  paymentTerms: '',
  paymentTermsID: '',
  backFromAddProduct: false,
  columnWidths: {}
}

const slice = createSlice({
  name: 'purchaseOrderManual',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setSupplier(state, action) {
      state.isLoading = false;
      state.supplier = action.payload;
    },

    setSupplierID(state, action) {
      state.isLoading = false;
      state.supplierID = action.payload;
    },

    setSupplierOfferID(state, action) {
      state.isLoading = false;
      state.supplierOfferID = action.payload;
    },

    setSubmissionDate(state, action) {
      state.isLoading = false;
      state.submissionDate = action.payload;
    },

    setReleaseDate(state, action) {
      state.isLoading = false;
      state.releaseDate = action.payload;
    },

    setPricingProfileID(state, action) {
      state.isLoading = false;
      state.pricingProfileID = action.payload;
    },

    setPricingProfileName(state, action) {
      state.isLoading = false;
      state.pricingProfileName = action.payload;
    },

    setPricingProfileDetail(state, action) {
      state.isLoading = false;
      state.pricingProfileDetail = action.payload;
    },

    setCostCurrency(state, action) {
      state.isLoading = false;
      state.costCurrency = action.payload;
    },

    setCostCurrencySymbol(state, action) {
      state.isLoading = false;
      state.costCurrencySymbol = action.payload;
    },

    setPurchaseOrderProducts(state, action) {
      state.isLoading = false;
      state.purchaseOrderProducts = action.payload;
    },

    setCurrAddProducts(state, action) {
      state.isLoading = false;
      state.currAddProducts = action.payload;
    },

    setBaseCurrency(state, action) {
      state.isLoading = false;
      state.baseCurrency = action.payload;
    },

    setBaseCurrencySymbol(state, action) {
      state.isLoading = false;
      state.baseCurrencySymbol = action.payload;
    },

    setShippingTerms(state, action) {
      state.isLoading = false;
      state.shippingTerms = action.payload;
    },

    setShippingTermsID(state, action) {
      state.isLoading = false;
      state.shippingTermsID = action.payload;
    },

    setPaymentTerms(state, action) {
      state.isLoading = false;
      state.paymentTerms = action.payload;
    },

    setPaymentTermsID(state, action) {
      state.isLoading = false;
      state.paymentTermsID = action.payload;
    },

    setBackFromAddProduct(state, action) {
      state.isLoading = false;
      state.backFromAddProduct = action.payload;
    },

    setColumnWidths(state, action) {
      state.isLoading = false;
      state.columnWidths = action.payload;
    },

    resetPurchaseOrderManual(state) {
      state.supplier = '';
      state.supplierID = '';
      state.supplierOfferID = '';
      state.submissionDate = '';
      state.releaseDate = '';
      state.pricingProfileID = '';
      state.costCurrency = '';
      state.costCurrencySymbol = '';
      state.purchaseOrderProducts = [];
      state.currAddProducts = [];
      state.baseCurrency = '';
      state.baseCurrencySymbol = '';
      state.pricingProfileName = '';
      state.pricingProfileDetail = null;
      state.shippingTerms = '';
      state.shippingTermsID = '';
      state.paymentTerms = '';
      state.paymentTermsID = '';
      state.backFromAddProduct = false;
      state.columnWidths = {};
    }
  }
})

// Reducer
export default slice.reducer;

export function setSupplier(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSupplier(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSupplierID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSupplierID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSupplierOfferID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSupplierOfferID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSubmissionDate(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSubmissionDate(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setReleaseDate(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setReleaseDate(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPricingProfileID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPricingProfileID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPricingProfileName(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPricingProfileName(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPricingProfileDetail(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPricingProfileDetail(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setCostCurrency(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setCostCurrency(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setCostCurrencySymbol(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setCostCurrencySymbol(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPurchaseOrderProducts(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPurchaseOrderProducts(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setCurrAddProducts(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setCurrAddProducts(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setBackFromAddProduct(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setBackFromAddProduct(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function resetPurchaseOrderManual() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.resetPurchaseOrderManual())
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setBaseCurrency(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setBaseCurrency(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setBaseCurrencySymbol(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setBaseCurrencySymbol(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setShippingTerms(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setShippingTerms(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setShippingTermsID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setShippingTermsID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPaymentTerms(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPaymentTerms(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setPaymentTermsID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setPaymentTermsID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setColumnWidths(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setColumnWidths(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}
